<template>
  <div class="shape-options-data-dialog"></div>
</template>

<script>
export default {
  name: "shape-options-data",
  components: {},
  data() {
    return {}
  },
  comments: {},
  mounted() {},
  computed: {},
  methods: {}
}
</script>

<style scoped></style>
